import type { ReactNode } from "react";

// Частите на прозореца „Инфо" (ItemDetailModal) по макета: описание като
// текст, ред чипове (време/калории в кехлибарено, таговете — в тона на
// добавките), „Съставки" като редове „име ····· количество", алергените в
// кехлибарена кутия. Само pos-* токени (всички имат тъмни стойности).

export const InfoEyebrow = ({
  children,
  className = "text-pos-dim",
}: {
  children: ReactNode;
  className?: string;
}) => (
  <span
    className={`shrink-0 font-pos-mono text-[11px] font-semibold uppercase tracking-[.1em] ${className}`}
  >
    {children}
  </span>
);

/** Чип в реда под описанието: „brand" = време/калории, „neutral" = таг. */
export const InfoChip = ({
  children,
  icon,
  imageSrc,
  tone = "neutral",
}: {
  children: ReactNode;
  icon?: ReactNode;
  imageSrc?: string | null;
  tone?: "brand" | "neutral";
}) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[13px] font-semibold leading-[1.4] ${
      tone === "brand"
        ? "border-pos-comment-brd bg-pos-ready-bg text-pos-accent-ink"
        : "border-pos-addon-brd bg-pos-addon-bg text-pos-ink2"
    }`}
  >
    {icon}
    {imageSrc && (
      <img src={imageSrc} alt="" className="h-4 w-4 object-contain" />
    )}
    {children}
  </span>
);

/** Ред от „Съставки": име, точкова линия до количеството, мерна единица. */
export const IngredientLine = ({
  name,
  badge,
  value,
  unit,
}: {
  name: string;
  /** Бадж до името (напр. „Рецепта" за под-рецепта). */
  badge?: string;
  value: string;
  unit?: string | null;
}) => (
  <div className="flex items-baseline gap-2 py-1.5">
    <span className="flex min-w-0 items-baseline gap-2">
      <span className="break-words text-[15px] font-bold text-pos-ink">
        {name}
      </span>
      {badge && (
        <span className="shrink-0 self-center rounded-full bg-pos-marked px-2 py-0.5 text-[11px] font-semibold text-pos-accent-ink">
          {badge}
        </span>
      )}
    </span>
    <span
      aria-hidden
      className="min-w-6 flex-1 translate-y-[-3px] border-b border-dotted border-pos-faint"
    />
    <span className="shrink-0 whitespace-nowrap font-pos-mono text-[14px] text-pos-ink">
      {value}
      {unit && <span className="ml-1.5 text-pos-muted">{unit}</span>}
    </span>
  </div>
);

/** Ред-заместител, докато съставките се зареждат. */
export const IngredientLineSkeleton = () => (
  <div className="flex items-center gap-3 py-2">
    <span className="h-3.5 w-2/5 animate-pulse rounded-md bg-pos-line2" />
    <span className="ml-auto h-3.5 w-16 animate-pulse rounded-md bg-pos-line2" />
  </div>
);

/** Кехлибарената кутия „Алергени" с чиповете вътре. */
export const AllergenBox = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-[14px] border border-pos-comment-brd bg-pos-marked px-4 py-3">
    <InfoEyebrow className="text-pos-accent-ink">{label}</InfoEyebrow>
    {children}
  </div>
);

/** Алерген: иконката от менюто + името, в бял чип. */
export const AllergenChip = ({
  name,
  imageSrc,
}: {
  name: string;
  imageSrc: string | null;
}) => (
  <span
    className={`inline-flex items-center gap-2 rounded-full border border-pos-line3 bg-pos-card py-1 pr-3 text-[13px] font-semibold text-pos-ink ${
      imageSrc ? "pl-1" : "pl-3"
    }`}
  >
    {imageSrc && (
      <img
        src={imageSrc}
        alt=""
        className="h-6 w-6 rounded-md object-contain"
      />
    )}
    {name}
  </span>
);
